import JSONAPIAdapter from "@ember-data/adapter/json-api";
import { Server } from "miragejs";
import { dataCenters } from "glesys-controlpanel/models/data-center";

const isMirageRunning = () => Boolean(window.server && window.server instanceof Server);

export default class DataCenterAdapter extends JSONAPIAdapter {
  findAll() {
    return Promise.resolve(
      isMirageRunning()
        ? window.server.db.dataCenters
        : // istanbul ignore next
          dataCenters,
    );
  }
}
